import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Concessionaria} from 'src/app/_model/concessionaria';
import {Documento} from 'src/app/_model/documento';
import {LoadingService} from 'src/app/_service/loading.service';
import {MessageService} from 'src/app/_service/message.service';
import {Email} from '../../_model/email';
import {LeadTecsinapse} from "../../_model/lead-tecsinapse";
import {LeadTecsinapseService} from "../../_service/lead-tecsinapse.service";
import {FormCotacaoVeiculosData} from "../../_model/form-cotacao-veiculos-data";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-form-cotacao-veiculos',
  templateUrl: './form-cotacao-veiculos.component.html',
  styleUrls: ['./form-cotacao-veiculos.component.scss']
})
export class FormCotacaoVeiculosComponent implements OnInit, OnDestroy {

  @Input()
  codigoTemplate: string;

  @Input()
  concessionarias: Concessionaria[];

  @Input()
  politicaPrivacidade: Documento;

  formGroup: FormGroup = {} as FormGroup;
  concessionariaSelecionada: string;
  isSubmitting = false;
  unsubcribeSubject$: Subject<void> = new Subject();


  mapFieldName = new Map<string, string>([
    ['nome', 'Nome'],
    ['email', 'Email'],
    ['telefone', 'Telefone'],
    ['cep', 'CEP'],
    ['concessionaria', 'Concessionária'],
    ['produto', 'Produto'],
    ['politicaPrivacidade', 'Aceite da Politica de Privacidade']
  ]);

  products = [
    {
      value: 'Caminhões',
      id: 'rbCaminhoes',
      label: 'Caminhões',
    },
    {
      value: 'Vans',
      id: 'rbVans',
      label: 'Vans',
    },
    {
      value: 'Ônibus',
      id: 'rbOnibus',
      label: 'Ônibus',
    },
    {
      value: 'Peças e Serviços',
      id: 'rbPecasServicos',
      label: 'Peças e Serviços',
    },
  ];

  constructor(private formBuilder: FormBuilder,
              private loadingService: LoadingService,
              private messageService: MessageService,
              private leadTecsinapseService: LeadTecsinapseService,
  ) {
  }

  ngOnInit(): void {
    this.montaForm();
  }

  ngOnDestroy(): void {
    this.unsubcribeSubject$.next();
    this.unsubcribeSubject$.complete();
  }

  montaForm(): void {
    this.formGroup = this.formBuilder.group({
      nome: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      telefone: ['', Validators.required],
      cep: ['', Validators.required],
      concessionaria: ['', [Validators.required]],
      produto: ['Caminhões', Validators.required],
      politicaPrivacidade: ['', Validators.requiredTrue]
    });
  }

  getCampo(formGroup: FormGroup, field: string): any {
    return formGroup.controls[field];
  }

  validaCampo(formGroup: FormGroup, field: string): boolean {
    return formGroup.controls[field].touched && !formGroup.controls[field].valid;
  }

  enviar(): void {
    if (this.isSubmitting) {
      return;
    }

    if (!this.formGroup.valid && !this.formGroup.pending) {
      Object.keys(this.formGroup.controls).forEach(key => {
        this.formGroup.get(key)?.markAsTouched();
      });

      return;
    }

    this.isSubmitting = true;
    this.loadingService.show();
    this.enviarLeadTecsinapse();
  }

  enviarLeadTecsinapse(): void {
    const formRawValues = this.formGroup.getRawValue() as FormCotacaoVeiculosData;

    const form: LeadTecsinapse = {
      formulario: `Cotação de veículo - ${this.concessionariaSelecionada}`,
      idEmpresa: formRawValues.concessionaria,
      tipo: 'WEB',
      origem: 'Site Institucional',
      tags: 'Cotação Veículo',
      produtoInteresse: formRawValues.produto,
      dadosPessoais: {
        nome: formRawValues.nome,
        email: formRawValues.email,
        telefone: formRawValues.telefone,
        cep: formRawValues.cep,
        optInEmail: true,
        optInSMS: true,
        optInTelefone: true,
        optInWhatsapp: false,
      }
    }

    this.leadTecsinapseService.salvarLead(form)
      .pipe(
        takeUntil(this.unsubcribeSubject$),
      ).subscribe(
      res => this.enviarSucess(res),
      err => this.enviarError(err)
    );
  }

  enviarError(err: any): void {
    this.isSubmitting = false;
    this.loadingService.hide();
    console.log(err);
    if (err.status === '404') {
      this.messageService.error('Não foi possível identificar o destinatário do e-mail.', 'Ocorreu um erro');
    } else {
      this.messageService.errorDefault();
    }
  }

  enviarSucess(res: any): void {
    this.isSubmitting = false;
    this.loadingService.hide();
    this.messageService.success('Sucesso', 'Cotação enviada com sucesso!');
    this.formGroup.reset();
  }

  public setConcessionaria(value: Event): void {
    const selectedOptions = value.target['options'];
    this.concessionariaSelecionada = selectedOptions[selectedOptions.selectedIndex].text;
  }
}
